<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>Nueva entretela</h3>
          <!-- <h4>Características básicas</h4> -->
          <!-- Form -->
          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <h4>Características</h4>

            <b-form-row>
              <b-col cols="6">
                <b-form-row>
                  <!-- Reference -->
                  <b-form-group
                    id="input-reference"
                    class="col-6"
                    label="Nombre de entretela"
                    label-for="reference"
                  >
                    <b-form-input
                      id="reference"
                      v-model="$v.form.reference.$model"
                      :state="validateState('reference')"
                      aria-describedby="input-reference-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-reference-feedback"
                      >Este campo es obligatorio.</b-form-invalid-feedback
                    >
                  </b-form-group>
                  <b-form-group
                    id="input-provider"
                    class="col-3"
                    label="Proveedor"
                    label-for="provider"
                  >
                    <b-form-input
                      id="provider"
                      v-model="$v.form.provider.$model"
                      :state="validateState('provider')"
                      aria-describedby="input-provider-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-provider-feedback"
                      >Este campo es obligatorio.</b-form-invalid-feedback
                    >
                  </b-form-group>
                  <b-form-group
                    id="input-ref_provider"
                    class="col-3"
                    label="Ref. proveedor"
                    label-for="ref_provider"
                  >
                    <b-form-input
                      id="ref_provider"
                      v-model="$v.form.ref_provider.$model"
                      :state="validateState('ref_provider')"
                      aria-describedby="input-ref_provider-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-ref_provider-feedback"
                      >Este campo es obligatorio.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-form-row>
                <b-form-row>
                  <!-- Medidas -->

                  <b-form-group
                    id="input-base_width"
                    class="col-6"
                    label="Medidas (Ancho x Largo)"
                    label-for="base_width"
                  >
                    <b-form-row>
                      <b-col :cols="6">
                        <b-input-group>
                          <b-form-input
                            id="base_width"
                            :value="$v.form.base_width.$model.replace('.', ',')"
                            @change="setDecimal('base_width', $event)"
                            :state="validateState('base_width')"
                            aria-describedby="input-base_width-feedback"
                          ></b-form-input>
                          <template #append>
                            <b-input-group-text>cm</b-input-group-text>
                          </template>
                        </b-input-group>
                        <b-form-invalid-feedback id="input-base_width-feedback"
                          >Este campo es obligatorio.</b-form-invalid-feedback
                        >
                      </b-col>
                      <b-col :cols="6">
                        <b-input-group>
                          <b-form-input
                            id="base_length"
                            :value="
                              $v.form.base_length.$model.replace('.', ',')
                            "
                            @change="setDecimal('base_length', $event)"
                            :state="validateState('base_length')"
                            aria-describedby="input-base_length-feedback"
                          ></b-form-input>
                          <template #append>
                            <b-input-group-text>cm</b-input-group-text>
                          </template>
                        </b-input-group>
                        <b-form-invalid-feedback id="input-base_length-feedback"
                          >Este campo es obligatorio.</b-form-invalid-feedback
                        >
                      </b-col>
                    </b-form-row>
                  </b-form-group>
                  <b-form-group
                    id="input-composition"
                    class="col-6"
                    label="Composición"
                    label-for="composition"
                  >
                    <multiselect
                      track-by="value"
                      :class="$v.form.composition.$error ? 'is-invalid' : ''"
                      :multiple="false"
                      :close-on-select="false"
                      :clear-on-select="true"
                      placeholder=""
                      label="text"
                      v-model="$v.form.composition.$model"
                      :options="form.optionsCompositions"
                    >
                    </multiselect>
                  </b-form-group>
                </b-form-row>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-form-group
                id="input-weight"
                class="col-3"
                label="Gramaje"
                label-for="weight"
              >
                <b-input-group>
                  <b-form-input
                    id="weight"
                    @change="setDecimal('weight', $event)"
                    :state="validateState('weight')"
                    aria-describedby="input-weight-feedback"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>g/m<sup>2</sup></b-input-group-text>
                  </template>
                </b-input-group>
                <b-form-invalid-feedback id="input-weight-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-cost"
                class="col-3"
                label="Coste"
                label-for="cost"
              >
                <b-input-group>
                  <b-form-input
                    id="cost"
                    @change="setDecimal('cost', $event)"
                    :state="validateState('cost')"
                    aria-describedby="input-cost-feedback"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>€</b-input-group-text>
                  </template>
                </b-input-group>

                <b-form-invalid-feedback id="input-cost-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-button type="submit" variant="primary"
              >Guardar nueva entretela</b-button
            >
          </b-form>
          <!-- /Form -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { required, decimal, minValue } from 'vuelidate/lib/validators';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import { helpers } from 'vuelidate/lib/validators';

import * as Sentry from '@sentry/browser';

import Multiselect from 'vue-multiselect';

import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

const isValidImage = (image) =>
  !helpers.req(image) || ['image/jpeg', 'image/png'].includes(image['type']);

export default {
  name: 'AdminInterliningsNewScreen',
  props: {},
  components: { Multiselect, VueCropper },
  mixins: [validationMixin],
  validations() {
    let rules = {
      reference: {
        required,
      },

      provider: { required },
      ref_provider: {
        required,
      },
      base_width: { required },
      base_length: { required },
      composition: { required },
      weight: { required },

      cost: {
        required,
        decimal,
        minValue: minValue(0.0),
      },
    };

    // this.languageCodes.map((x) => {
    //   rules['name_' + x] = { required };
    // });

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      reference: '',
      provider: '',
      ref_provider: '',
      base_width: '',
      base_length: '',
      composition: [],
      weight: '',
      cost: '',

      error: {
        show: false,
        text: '',
      },
      optionsCompositions: [],
      optionsColorFamilies: [],
      optionsDesigns: [],
    };

    // store.getLanguageCodes().map((x) => {
    //   form['name_' + x] = '';
    // });

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes().filter((x) => x == 'es'),
      languageNames: store.getLanguageNames(),
      form: form,
    };
  },
  created() {
    let preloadPromises = [];

    preloadPromises.push(
      actions.getFabricCompositions(),
      actions.getFabricColorFamilies(),
      actions.getFabricDesigns()
    );

    Promise.all(preloadPromises).then((z) => {
      this.form.optionsCompositions = z[0].data.results.map((y) => {
        return {
          value: y.id,
          text: y.name,
        };
      });

      this.form.optionsColorFamilies = z[1].data.results.map((y) => {
        return {
          value: y.id,
          text: y.name,
        };
      });

      this.form.optionsDesigns = z[2].data.results.map((y) => {
        return {
          value: y.id,
          text: y.name,
        };
      });
    });
  },
  methods: {
    getDataURIFromFile(file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = () => resolve(fileReader.result);
        fileReader.readAsDataURL(file);
      });
    },
    changedImage(newFile) {
      this.getDataURIFromFile(newFile).then((result) => {
        this.form.imageURI = result;
      });
    },
    cropIcon() {
      this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
        // Pass the image file name as the third parameter if necessary.

        this.form.icon = blob;

        this.getDataURIFromFile(blob).then((result) => {
          this.form.iconURI = result;
        });
      });
    },

    setDecimal(name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form[name].$model = val;
      this.$v.form[name].$touch();
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      store.setOverlayShow(true);

      let data = new FormData();

      data.append('reference', this.form.reference);

      data.append('provider', this.form.provider);
      data.append('ref_provider', this.form.ref_provider);

      data.append('base_width', this.form.base_width);
      data.append('base_length', this.form.base_length);

      data.append('composition', JSON.stringify([this.form.composition.value]));

      data.append('weight', this.form.weight);

      data.append('cost', this.form.cost);

      // this.languageCodes.map((x) => {
      //   data.append('name_' + x, this.form['name_' + x]);
      // });

      // data.append('name', this.form['name_' + this.languageCodes[0]]);

      Sentry.setExtra('data', JSON.stringify(Object.fromEntries(data)));
      actions.postInterlining(data).then((x) => {
        this.$router.push({ name: 'AdminInterliningsScreen' });
      });
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
